<template>
  <div class="background_index_concept">
    <div class="index_concept_text">
      <p style=" font-size: 22px;margin-bottom: 0.5vh;">投资理念</p>
      <p style="padding-bottom: 1vh">——————</p>
      <p>我们无法预测哪里有价值洼地，但出现洼地的地方，</p>
      <p>我们会出现，这是勤奋，也是风格。</p>
      <p>是我们选择了快速生成的洼地，也是新崛起的力量选择了我们。</p>
      <a-row class="index_concept_card">
        <a-col :span="8">
          <img src="../../../assets/image/index_concept_card_1.png" class="card_img">
          <p style="padding-top: 1vh">———</p>
          <p style="font-size: 15px;">早 | 直觉</p>
          <p class="card_text">浩茫广宇</p>
          <p class="card_text">于无声处听惊雷</p>
        </a-col>
        <a-col :span="8">
          <img src="../../../assets/image/index_concept_card_2.png" class="card_img">
          <p style="padding-top: 1vh">———</p>
          <p style="font-size: 15px;">快 | 决断</p>
          <p class="card_text">厚积薄发</p>
          <p class="card_text">当断之机则立断</p>
        </a-col>
        <a-col :span="8">
          <img src="../../../assets/image/index_concept_card_3.png" class="card_img">
          <p style="padding-top: 1vh">———</p>
          <p style="font-size: 15px;">远 | 眼界</p>
          <p class="card_text">除却浮云</p>
          <p class="card_text">风物长宜放眼量</p>
        </a-col>
      </a-row>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>
<script>
import {DownOutlined} from "@ant-design/icons-vue/"

export default {
  name: 'Index_concept_m',
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })


    }
    return {next_page}
  },
  components: {
    DownOutlined,
  }
}
</script>
<style scoped>
.background_index_concept {
  background-image: url("../../../assets/background/index_concept.jpg");
  height: 100vh;

  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_concept_text {
  padding-top: 25vh;
  height: 92vh;
}

.index_concept_text p {
  font-size: 12px;
}

.index_concept_card {
  padding-top: 4vh;
  color: white;
}

.card_img {
  width: 45px;
}

.card_text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>